<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader @import-event="importFile" @export-event="exportFile" :renderImport="!isLoading" :renderExport="!isLoading" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							
							<div class="row p-3">
								<div class="col-md-6">
									<Button class="p-button-sm" @click="add" label="Create New Country"/>
								</div>
							</div>
							
							<div class="row p-3 pb-0">
								<label><b>Search existing Country by:</b></label>
							</div>
							
							<div class="row p-3">
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="filterCodeModel.value" />
								</div>
								
								<div class="col-md-4">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Name" v-model="filterNameModel.value" />
								</div>
									
								<div class="col-md-4">
									<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>
							</div>
							
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>
									
								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 15%; cursor: pointer;" @click="sort('x.code')">Code <span class="pi" :class="[sortingModel.columnName == 'x.code' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 62%; cursor: pointer;" @click="sort('x.name')">Name <span class="pi" :class="[sortingModel.columnName == 'x.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 15%;" class="text-center">Status</th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(country, index) in pagination.countries" :key="index" v-on:click="view(country)">
												<td>{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td>{{country.code}}</td>
												<td>{{country.name}}</td>
												<td class="text-center">
													<Badge class="mr-2" :class="[country.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']" :value="country.status"></Badge>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								
								<div class="error-no-record" v-if="!isLoading && pagination.countries.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>
						
						<TheInvalidImportDialog title="Country" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import countryApi from "@/api/country-api";
	import statusMixin from "@/mixin/status";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue";
	
	export default defineComponent({
		mixins: [statusMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheInvalidImportDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, countries: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.code", isAscending: true} : store.getters.getCached.page.sortingModel),
				filterCodeModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterCodeModel),
				filterNameModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterNameModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				isLoading: false,
				isImporting: false,
				isExporting: false,
				isDialogVisible: false,
				invalidData: {} as any
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			}
		},
		methods: {
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;
				
				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterCodeModel: JSON.parse(JSON.stringify(this.filterCodeModel)),
					filterNameModel: JSON.parse(JSON.stringify(this.filterNameModel)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
				};
				
				countryApi.countryFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterCodeModel: this.filterCodeModel,
						filterNameModel: this.filterNameModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, countries: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, countries: [], totalItems: 0};
				this.sortingModel = {columnName: "x.code", isAscending: true};
				this.filterCodeModel = {value: ""};
				this.filterNameModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/admin/country/add");
			},
			view(country: any) {
				this.$router.push("/admin/country/view/" + country.identifier);
			},
			importFile(file: any) {
				this.isImporting = true;

				var formData = new FormData();
				formData.append('file', file[0]);

				countryApi.countryImport(formData)
					.then((response: any) => {
						this.isImporting = false;
						if (response.data == null || response.data == '') {
							this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
							this.find(1);
						}

						else {
							this.invalidData = response.data;
							this.isDialogVisible = true;
						}
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport(isOverride: boolean) {
				this.isImporting = true;

				let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));
				
				if (isOverride == false && tempInvalidData.warningCount > 0) {
					tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
						if (invalidRow.type == "Warning") {
							invalidRow.type = "Error";
							return invalidRow;
						}
					});
				}

				countryApi.countryImportProceed({'invalidData': tempInvalidData})
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.isDialogVisible = false;
						this.find(1);
					})
					.catch(error => {
						this.isImporting = false;
						this.isDialogVisible = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			exportFile() {
				this.isExporting = true;
				
				countryApi.countryExport({
						filterCodeModel: this.filterCodeModel,
						filterNameModel: this.filterNameModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeDialog() {
				this.isDialogVisible = false;
			}
		}
	});
</script>
